var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2"},[_c('table-component',{attrs:{"data":_vm.products,"headers":_vm.headers,"pagination":_vm.pagination,"rowActions":_vm.rowActions,"loading":_vm.loading},on:{"changePagination":_vm.changePagination}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }